import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import clienteAxios from '../helpers/axios.helper';
import Swal from 'sweetalert2'; // Importar SweetAlert2
import Logo from '../components/navbar/Logo';

function Registro() {
  const navigate = useNavigate();
  const [nombre, setNombre] = useState('');
  const [apellido, setApellido] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      Swal.fire({
        title: 'Error!',
        text: 'Las contraseñas no coinciden.',
        icon: 'error',
        confirmButtonText: 'Cerrar',
      });
      return;
    }

    try {
      const response = await clienteAxios.post('/usuarios/registro', {
        nombre,
        email,
        contrasenia: password,
      });

      if (response.status === 201) {
        Swal.fire({
          title: '¡Registrado!',
          text: 'Usuario registrado exitosamente.',
          icon: 'success',
          confirmButtonText: 'Aceptar',
        }).then(() => {
          navigate('/agroh_panel'); // Redirige a la página de inicio de sesión
        });
      }
    } catch (error) {
      console.error('Error al registrar usuario:', error);
      Swal.fire({
        title: 'Error!',
        text: 'Hubo un error al registrar al usuario. Por favor, inténtalo de nuevo.',
        icon: 'error',
        confirmButtonText: 'Cerrar',
      });
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-carritoshadow max-w-3xl w-full flex flex-col md:flex-row">
        <div className="flex flex-col items-center justify-center w-full md:w-1/2 pr-0 md:pr-8 mb-8 md:mb-0">
          <Logo size={'w-60 xl:w-72'} />
          <h2 className="my-4 text-lg font-semibold text-center text-GrisOscuro italic">
            "Impulsando tu campo, creciendo juntos."
          </h2>
        </div>

        <div className="border-b md:border-b-0 md:border-r border-gray-300 mx-4 md:mx-0"></div>

        <div className="w-full md:w-1/2 pl-0 md:pl-8">
          <h2 className="text-2xl font-bold text-center mb-4">Registrarse</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="nombre" className="block text-sm font-medium text-gray-700">
                Nombre
              </label>
              <input
                type="text"
                id="nombre"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                required
                className="mt-1 block w-full px-3 py-2 border border-GrisOscuro rounded-md shadow-sm focus:outline-none focus:ring-Verde focus:border-Verde sm:text-sm"
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Correo Electrónico
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1 block w-full px-3 py-2 border border-GrisOscuro rounded-md shadow-sm focus:outline-none focus:ring-Verde focus:border-Verde sm:text-sm"
              />
            </div>
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Contraseña
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="mt-1 block w-full px-3 py-2 border border-GrisOscuro rounded-md shadow-sm focus:outline-none focus:ring-Verde focus:border-Verde sm:text-sm"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-GrisOscuro hover:text-GrisOscuro focus:outline-none"
                >
                 <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    {showPassword ? (
                      <>
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </>
                    ) : (
                      <>
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                        <line x1="4" y1="4" x2="20" y2="20" />
                      </>
                    )}
                  </svg>
                </button>
              </div>
            </div>

            <div>
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
                Confirmar Contraseña
              </label>
              <div className="relative">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  className="mt-1 block w-full px-3 py-2 border border-GrisOscuro rounded-md shadow-sm focus:outline-none focus:ring-Verde focus:border-Verde sm:text-sm"
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-GrisOscuro hover:text-GrisOscuro focus:outline-none"
                >
                 <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    {showPassword ? (
                      <>
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </>
                    ) : (
                      <>
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                        <line x1="4" y1="4" x2="20" y2="20" />
                      </>
                    )}
                  </svg>
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="w-full py-2 px-4 border border-Negro rounded-md shadow-sm text-base font-medium text-Blanco bg-Verde hover:bg-GrisClaro hover:text-Negro focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Registrarse
            </button>
            <button
              type="button"
              className="w-full py-2 px-4rounded-md text-base mt-1 text-Verde hover:text-Negro font-medium"
              onClick={() => navigate('/agroh_panel')}
            >
              Iniciar Sesión
            </button>

          </form>
        </div>
      </div>
    </div>
  );
}

export default Registro;
